import React from "react";
import { serverURL } from "../../services/NodeServices";
import RatingDisplay from "../../components/ReviewComp/ReviewComp";

const ProductCard = ({  gsm, base_price, current_price, name,image_url,
    avg_rating, rev_count,onProductClick,product_id,variants

    


}) => {


 let colors = variants?.reduce((acc, item) => {
  if (!acc.includes(item.color)) {
    acc.push(item.color);
  }
  return acc;
}, [])||[]

    


  return (
    <div className="bg-[#fff] p-1 flex-[0_0_271px] max-w-[271px] w-[271px] cursor-pointer max-sm:flex-[0_0_171px]" onClick={()=>{onProductClick(product_id)}}>
      <div className="relative">
        <img src={`${serverURL}images/${image_url}`} alt={name} className="w-full object-cover aspect-[.7]" />
        {/* <img src={`${serverURL}shirts/${image_url}`} alt={name} className="w-full object-cover aspect-[.7]" /> */}
        <span className="absolute bottom-2 right-2 bg-[#7e6b56] text-white text-xs font-semibold py-1 px-2 rounded-full">
          {parseInt((base_price-current_price)/base_price*100)} % OFF
        </span>
      </div>
      <div className="mt-2">
        <h3 className=" text-sm text-left w-full font-pop text-[#444]">{name}</h3>
        <p className="text-xs text-gray-600">{gsm}</p>
        <div className="flex items-center space-x-2 mt-1">
          <p className="line-through text-sm text-gray-400">₹ {base_price}</p>
          <p className="text-sm font-semibold">₹ {current_price}</p>
        </div>

        <div className="flex items-center gap-1 mt-3">
          {colors.map((color, index) => (
            <span
              key={index}
              className="w-4 h-4 rounded-full border border-gray-300"
              style={{ backgroundColor: color }}
            ></span>
          ))}
          <span className="ml-1 font-bold text-sm">+</span>
        </div>
      </div>
        <RatingDisplay averageRating={avg_rating} totalRatings={rev_count} />
    </div>
  );
};

export default ProductCard;
